export default {"src":"/_next/static/image/src/components/icons/weather-forecast.666e622289f1bbfe34980aa63075e3d0.svg","height":54,"width":50};